<template>
    <div class="scope-cent8">
        <div class="scope-item" v-for="(item, i) in pointMap" :key="i"
            :style="{left: item.left + 'px',top: item.top + 'px'}" @mouseover="pointover(i)"
            @mouseleave="pointout(i)">
            <div v-if="activeindex !== i">
                {{item.name}}
                <div class="point">
                    <img src="@/assets/temimg15/map/hot-point.png" alt="" v-if="item.ishot">
                    <img src="@/assets/temimg15/map/default-point.png" alt="" v-else>
                </div>
            </div>
            <div v-else class="active-point">
                {{ item.name }}
            </div>
        </div>
        <div class="active-cont">
            <img :src="getActive(activeindex)" alt="">
        </div>
        <div class="right-view" :style="{left: pointMap[activeindex].left1 + 'px', top: pointMap[activeindex].top1 + 'px'}" v-show="stopauto">
            <div class="right-v-title">
                {{ activeList.value1 }}
            </div>
            <div class="right-v-line">
                <div class="line-a" :style="{width: +activeList.value15 + '%'}">
                    <div class="line-text">
                        A：{{activeList.value15 }}%
                    </div>
                </div>
                <div class="line-b" :style="{width: +activeList.value16 + '%'}">
                    <div class="line-text">
                        B：{{activeList.value16 }}%
                    </div>
                </div>
                <div class="line-c" :style="{width: +activeList.value17 + '%'}">
                    <div class="line-text">
                        C：{{activeList.value17 }}%
                    </div>
                </div>
                <div class="line-d" :style="{width: +activeList.value18 + '%'}">
                    <div class="line-text">
                        D：{{activeList.value18 }}%
                    </div>
                </div>
            </div>
            <div class="right-v-list">
                <div class="list-item" v-for="item in 8" :key="item">
                    {{ valueMap[item + 1].name }}:
                    <span>
                    {{ activeList[`value${item + 1}`] }}
                    </span>
                </div>
            </div>
            <div class="gap-line"></div>
            <div class="right-v-list">
                <div class="list-item" v-for="item in 5" :key="item">
                    {{ valueMap[item + 8].name }}:
                    <span>
                    {{ activeList[`value${item + 8}`] }}
                    </span>
                </div>
            </div>
        </div>
        <div class="rotate-cont">
            <img src="@/assets/temimg15/map/circle2.png" class="circle2" alt="">
            <img src="@/assets/temimg15/map/circle1.png" class="circle1" alt="">
        </div>
        <img src="@/assets/temimg15/map/map-bg.png" alt="" class="bgimg">
    </div>
</template>

<script>
import * as methods from "@/components/scope/method.js";

export default {
    name: "template8.center",
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            defaultdata: [
                { value1: '杏陈镇', value2: '1090', value3: '1090', value4: '1090', value5: '1090', value6: '1090', value7: '1090', value8: '1090', value9: '1090', value10: '1090', value11: '1090', value12: '1090', value13: '1090', value14: '1090', value15: '30', value16: '20', value17: '25', value18: '25' },
                { value1: '西埔镇', value2: '1090', value3: '1090', value4: '1090', value5: '1090', value6: '1090', value7: '1090', value8: '1090', value9: '1090', value10: '1090', value11: '1090', value12: '1090', value13: '1090', value14: '1090', value15: '30', value16: '20', value17: '25', value18: '25' },
                { value1: '樟塘镇', value2: '1090', value3: '1090', value4: '1090', value5: '1090', value6: '1090', value7: '1090', value8: '1090', value9: '1090', value10: '1090', value11: '1090', value12: '1090', value13: '1090', value14: '1090', value15: '30', value16: '20', value17: '25', value18: '25' },
                { value1: '康美镇', value2: '1090', value3: '1090', value4: '1090', value5: '1090', value6: '1090', value7: '1090', value8: '1090', value9: '1090', value10: '1090', value11: '1090', value12: '1090', value13: '1090', value14: '1090', value15: '30', value16: '20', value17: '25', value18: '25' },
                { value1: '铜陵镇', value2: '1090', value3: '1090', value4: '1090', value5: '1090', value6: '1090', value7: '1090', value8: '1090', value9: '1090', value10: '1090', value11: '1090', value12: '1090', value13: '1090', value14: '1090', value15: '30', value16: '20', value17: '25', value18: '25' },
                { value1: '前楼镇', value2: '1090', value3: '1090', value4: '1090', value5: '1090', value6: '1090', value7: '1090', value8: '1090', value9: '1090', value10: '1090', value11: '1090', value12: '1090', value13: '1090', value14: '1090', value15: '30', value16: '20', value17: '25', value18: '25' },
                { value1: '陈城镇', value2: '1090', value3: '1090', value4: '1090', value5: '1090', value6: '1090', value7: '1090', value8: '1090', value9: '1090', value10: '1090', value11: '1090', value12: '1090', value13: '1090', value14: '1090', value15: '30', value16: '20', value17: '25', value18: '25' },
            ],
            valueMap: [
                { name: '地区', key: 'value1' },
                { name: '纳管总数', key: 'value2' },
                { name: '扫码次数', key: 'value3' },
                { name: '食品餐饮', key: 'value4' },
                { name: '特种设备', key: 'value5' },
                { name: '药品药店', key: 'value6' },
                { name: '农村聚餐', key: 'value7' },
                { name: '学校食堂', key: 'value8' },
                { name: '托餐机构', key: 'value9' },
                { name: '经营商户', key: 'value10' },
                { name: '监控接入', key: 'value11' },
                { name: '从业人员', key: 'value12' },
                { name: '从业证件合格占比', key: 'value13' },
                { name: '购买食安险', key: 'value14' },
                { name: '信用A级占比', key: 'value15' },
                { name: '信用B级占比', key: 'value16' },
                { name: '信用C级占比', key: 'value17' },
                { name: '信用D级占比', key: 'value18' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            autoTimePaused: false,
            pointMap: [
                { name: '杏陈镇', left: '210', top: '102', left1: '90', top1: '160', ishot: false, url: 'xcz.png' },
                { name: '西埔镇', left: '364', top: '228', left1: '235', top1: '288', ishot: false, url: 'xpz.png' },
                { name: '樟塘镇', left: '412', top: '153', left1: '284', top1: '205', ishot: false, url: 'ztz.png' },
                { name: '康美镇', left: '564', top: '118', left1: '432', top1: '172', ishot: false, url: 'kmz.png' },
                { name: '铜陵镇', left: '674', top: '102', left1: '510', top1: '152', ishot: false, url: 'tlz.png' },
                { name: '前楼镇', left: '200', top: '220', left1: '66', top1: '274', ishot: false, url: 'qlz.png' },
                { name: '陈城镇', left: '230', top: '480', left1: '305', top1: '342', ishot: true, url: 'ccz.png' },
            ],
            activename: '',
            stopauto: false,
            activeindex: 0,
            timer1: null,
            activeList: [],
        }
    },
    watch: {
        activeindex(n) {
            this.getacList()
        }
    },
    methods: {
        ...methods,
        getActive(index) {
            let active = this.pointMap[index]
            let url = active.url
            if (url) {
                return require(`@/assets/temimg15/map/${url}`)
            } else {
                return ''
            }
        },
        pointover(i) {
            this.activeindex = i
            this.stopauto = true
        },
        pointout() {
            this.stopauto = false
        },
        autoplay() {
            if (this.stopauto) {
                clearTimeout(this.timer1)
                this.timer1 = null
            }
            if (this.activeindex < this.pointMap.length - 1) {
                this.activeindex = this.activeindex + 1
            } else {
                this.activeindex = 0
            }
        },
        getacList() {
            this.activeList = this.defaultdata.find(item => item.value1 == this.pointMap[this.activeindex].name)
        }
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.autoplay()
        this.timer1 = setInterval(() => {
            this.autoplay()
        }, 3000);
    },
    beforeDestroy() {
        clearInterval(this.timer1)
        this.timer1 = null
    }
}
</script>

<style scoped lang="scss">
.scope-cent8 {
    width: 765px;
    height: 639px;
    position: relative;
    margin: 0 auto;
    pointer-events: auto;
    margin-top: -55px;
    z-index: -1;
    .bgimg {
        width: 100%;
        height: 100%;
        z-index: -1;
        position: absolute;
        left: 0;
        top: 0;
    }
    .scope-item {
        position: absolute;
        font-family: Benmo Ziyu;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 20px;
        text-shadow: 0px 2px 2px rgba(20,71,129,0.66);
        text-align: center;
        .point {
            width: 33.5px;
            height: 26px;
            margin: 0 auto;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .active-point {
        position: absolute;
        width: 183px;
        height: 184px;
        background: url(@/assets/temimg15/map/active-bg.png) no-repeat;
        background-size: 100% 100%;
        left: -60px;
        top: -54px;
        text-align: center;
        padding-top: 50px;
        box-sizing: border-box;
        z-index: 2;
        cursor: pointer;
    }
    .active-cont {
        width: 100%;
        height: 100%;
        pointer-events: none;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        font-family: Benmo Ziyu;
        font-weight: 400;
        font-size: 20px;
        color: #875012;
        line-height: 20px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .right-view {
        position: absolute;
        // right: -66px;
        // bottom: 58px;
        width: 344px;
        height: 240px;
        background: url(@/assets/temimg15/log-bg.png) no-repeat;
        background-size: 100% 100%;
        z-index: 5;
    }
    .right-v-title {
        font-family: 'pmzd';
        font-size: 17px;
        color: #FFFFFF;
        line-height: 17px;
        padding: 8px 0 0 36px;
    }
    .right-v-line {
        display: flex;
        align-items: center;
        position: relative;
        margin: 42px 16px 0
    }
    .line-a {
        position: relative;
        height: 10px;
        background: linear-gradient(to right, rgba(9, 121, 245, .4), rgba(9, 121, 245, 1));
    }
    .line-b {
        position: relative;
        height: 10px;
        background: linear-gradient(to right, rgba(87, 232, 203, .4), rgba(87, 232, 203, 1));
    }
    .line-c {
        position: relative;
        height: 10px;
        background: linear-gradient(to right, rgba(0, 217, 255, .4), rgba(0, 217, 255, 1));
    }
    .line-d {
        position: relative;
        height: 10px;
        background: linear-gradient(to right, rgba(166, 230, 255, .4), rgba(166, 230, 255, 1));
    }
    .line-text {
        top: -18px;
        width: 100%;
        position: absolute;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 13px;
        color: #FFFFFF;
        line-height: 13px;
        text-align: center;
        font-style: normal;
        text-transform: none;
    }
    .right-v-list {
        display: flex;
        flex-wrap: wrap;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 12px;
        color: #C3DCFF;
        margin: 15px 16px 0;
        row-gap: 4px;
        column-gap: 16px;
        .list-item {
        }
        span {
            color: #FFFFFF;
        }
    }
    .gap-line {
        margin: 8px 16px;
        height: 1px;
        background: rgba(116, 120, 125, 1);
    }
    .rotate-cont {
        position: absolute;
        transform: rotateX(42deg);
        z-index: -1;
        top: 11px;
        left: -53px;
        img {
            width: 851px;
            height: 851px;
            position: absolute;
            top: 0;
            left: 0;
        }
        .circle1 {
            animation: rotateleft 5s linear infinite;
        }
        .circle2 {
            animation: rotateright 5s linear infinite;
            z-index: 1;
        }
    }
}
@keyframes rotateleft {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes rotateright {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(-360deg);
    }
}
</style>